export const Svg_117 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M17.573 61.25 6.417 50.094l11.156-11.157 3.573 3.573-5.031 5.032h37.917L49 42.51l3.573-3.572L63.73 50.093 52.573 61.25 49 57.677l5.032-5.031H16.114l5.031 5.031-3.573 3.573ZM7.292 30.99v-.948a5.07 5.07 0 0 1 .832-2.819c.554-.853 1.322-1.494 2.303-1.92a21.406 21.406 0 0 1 3.763-1.187 19.076 19.076 0 0 1 4.044-.418c1.407 0 2.754.14 4.04.418 1.288.28 2.54.675 3.758 1.186.98.427 1.748 1.068 2.303 1.922.555.854.832 1.793.832 2.818v.948H7.292Zm33.687 0v-.948c0-1.025.278-1.965.832-2.819.555-.853 1.323-1.494 2.304-1.92a21.406 21.406 0 0 1 3.762-1.187 19.076 19.076 0 0 1 4.044-.418c1.407 0 2.754.14 4.041.418 1.288.28 2.54.675 3.757 1.186.981.427 1.749 1.068 2.303 1.922.555.854.832 1.793.832 2.818v.948H40.98ZM18.226 19.688c-1.505 0-2.792-.536-3.861-1.608-1.07-1.071-1.604-2.36-1.604-3.864 0-1.505.535-2.792 1.607-3.862 1.072-1.07 2.36-1.604 3.865-1.604 1.504 0 2.791.536 3.861 1.607 1.07 1.072 1.604 2.36 1.604 3.865 0 1.505-.536 2.792-1.607 3.861-1.072 1.07-2.36 1.605-3.865 1.605Zm33.688 0c-1.505 0-2.792-.536-3.862-1.608-1.07-1.071-1.604-2.36-1.604-3.864 0-1.505.536-2.792 1.608-3.862 1.071-1.07 2.36-1.604 3.864-1.604 1.505 0 2.792.536 3.861 1.607 1.07 1.072 1.605 2.36 1.605 3.865 0 1.505-.536 2.792-1.608 3.861-1.071 1.07-2.36 1.605-3.864 1.605Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={19.67}
        x2={43.577}
        y1={16.625}
        y2={58.862}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)